export default __webpack_public_path__ + "static/media/Class_2_Mobile.f382c563.jpg";